module.exports = __webpack_public_path__ + "img/sj_gangtiejiagong.93bc8aa9.jpg";